import { CheckCircle2 } from "lucide-react";

/**
 * Selo "Verificado" no rosa da plataforma. Aparece junto ao nome do artista.
 * Use como <VerifiedBadge size={18} /> ou <VerifiedBadge tooltip="Artista oficial" />
 */
export default function VerifiedBadge({ size = 18, className = "", tooltip = "Artista verificado" }) {
  return (
    <span
      title={tooltip}
      className={`inline-flex items-center text-[#FF007F] ${className}`}
      data-testid="verified-badge"
      aria-label={tooltip}
    >
      <CheckCircle2 size={size} fill="#FF007F" stroke="white" strokeWidth={2.5} />
    </span>
  );
}
